import { render, staticRenderFns } from "./NotificationSettingsView.vue?vue&type=template&id=b056049a"
import script from "./NotificationSettingsView.vue?vue&type=script&lang=ts"
export * from "./NotificationSettingsView.vue?vue&type=script&lang=ts"
import style0 from "./NotificationSettingsView.vue?vue&type=style&index=0&id=b056049a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports